<template>
  <div :class="stateClass" class="link-copier">
    <button class="link-copier__button-copy" @click="copy">
      <bpb-icon icon="i-link" label-path="copier.copy" />
    </button>
    <input
      ref="input"
      :name="`link-copier-input-${id}`"
      :value="url"
      class="link-copier__input"
      readonly
      @click="mark"
    />
  </div>
</template>

<script>
import { animationFrame } from '@js/utils/animation';
import { CopierEventBus } from '@js/eventBus';

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isClicked: false,
    };
  },
  computed: {
    stateClass() {
      return {
        'link-copier--is-clicked': this.isClicked === true,
      };
    },
  },
  mounted() {
    CopierEventBus.$on('copier-copy', this.remoteCopy);
  },
  beforeDestroy() {
    CopierEventBus.$off('copier-copy', this.remoteCopy);
  },
  methods: {
    mark() {
      this.$refs.input.select();
    },
    remoteCopy({ targetId }) {
      if (targetId !== this.id) return;
      this.copy();
    },
    copy() {
      this.mark();
      this.$nextTick(() => {
        document.execCommand('copy');
      });

      this.isClicked = true;
      animationFrame().then(() => {
        this.isClicked = false;
      });
    },
  },
};
</script>
